import {
  ACTIONS_COL_WIDTH,
  ActionsDropdown,
  CombinedText,
  DarwinFlex,
  DMenuProps,
  DTableProps,
  STATUS_COL_WIDTH,
  StatusChip,
} from 'components/darwin-ui';
import Icon from 'components/darwin-ui/Icon';
import { TFunction } from 'i18next';
import { ColumnAction } from '.';
import { CreatedBy, DataCaptureListView } from 'types/dataCaptureTypes';
import { renderUserCell, renderDateCell } from '@darwin-ui';
import {
  ProcessLifeCycleStatus,
  getProcessStatusColor,
  getProcessStatusLabel,
} from 'constants/process-lifecycle-status.constants';

export const getDataCaptureFormsColumns = (
  t: TFunction,
  actions: ColumnAction[],
  searchQuery: string
) => {
  const menuItems = (
    dataCaptureForm: DataCaptureListView
  ): DMenuProps['items'] =>
    actions.map(action => ({
      key: action.key,
      label: (
        <DarwinFlex
          gap={8}
          align="center"
          onClick={() => action?.onClick?.(dataCaptureForm)}
        >
          <Icon
            name={action.name ? action.name : 'darwin-user'}
            size="sm"
            color="inherit"
          />
          {action.label}
        </DarwinFlex>
      ),
    }));

  const renderUserCol = (user: string) => renderUserCell(user, searchQuery);
  const renderDateCol = renderDateCell;

  const columns: DTableProps<DataCaptureListView>['columns'] = [
    {
      title: t('data-capture-list-view.form-name'),
      dataIndex: 'form_name',
      key: 'name',
      sorter: true,
      render: (name: string) => (
        <CombinedText lines={1} text={name} highlight={searchQuery} />
      ),
      width: 200,
    },
    {
      title: t('data-capture-list-view.template-name'),
      dataIndex: 'template_name',
      key: 'templateName',
      sorter: true,
      render: (tempalteName: string) => (
        <CombinedText lines={1} text={tempalteName} highlight={searchQuery} />
      ),
      width: 200,
    },
    {
      title: t('created-by'),
      dataIndex: 'created_by',
      key: 'createdBy',
      sorter: true,
      render: (record: CreatedBy) => {
        if (!record || record.first_name == null) return renderUserCol('');
        const name = `${record.first_name || ''} ${record.last_name || ''}`;
        return renderUserCol(name);
      },
    },
    {
      title: t('created-at'),
      dataIndex: 'created_at',
      key: 'createdAt',
      sorter: true,
      render: renderDateCol,
      align: 'center',
    },
    {
      title: t('updated-by'),
      dataIndex: 'updated_by',
      key: 'updatedBy',
      sorter: true,
      render: (record: any) => {
        if (!record || record.first_name == null) return renderUserCol('');
        const name = `${record.first_name || ''} ${record.last_name || ''}`;
        return renderUserCol(name);
      },
    },
    {
      title: t('updated-at'),
      dataIndex: 'updated_at',
      key: 'updatedAt',
      sorter: true,
      render: renderDateCol,
      align: 'center',
      width: 200,
    },
    {
      title: t('status'),
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      align: 'center',
      render: (status: string) => {
        return (
          <StatusChip
            color={getProcessStatusColor(status as ProcessLifeCycleStatus)}
            label={getProcessStatusLabel(status as ProcessLifeCycleStatus, t)}
          />
        );
      },
      width: STATUS_COL_WIDTH,
    },
    {
      dataIndex: 'actions',
      key: 'actions',
      fixed: 'right',
      align: 'center',
      render: (_, process) => (
        <ActionsDropdown item={process} getMenuItems={menuItems} />
      ),
      width: ACTIONS_COL_WIDTH,
    },
  ];

  return columns;
};
